import React, { FC, ReactNode } from 'react'

import { InfoTooltip } from '@/atoms/info-tooltip'
import { Flex } from '@/atoms/layout'
import { Legend } from '@/atoms/typography'
import { Space } from '@/styles'

interface Props {
  children: ReactNode
  sectionTooltip?: string
  sectionDescription?: string
}

export const SectionTitle: FC<Props> = ({ sectionDescription, children, sectionTooltip }) => (
  <Flex width={1} mb={sectionDescription ? Space.S4 : Space.S12} px={Space.S12}>
    <Legend>{children}</Legend>
    {sectionTooltip && <InfoTooltip tooltipText={sectionTooltip} pl={Space.S8} />}
  </Flex>
)
